"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundReportanMoney = roundReportanMoney;
exports.parseReportanMoney = parseReportanMoney;
exports.normalizeReportanSource = normalizeReportanSource;
exports.getIgorPayrollPeriodBounds = getIgorPayrollPeriodBounds;
exports.calculateIgorPayroll = calculateIgorPayroll;
const IGOR_SOURCE = 'игорь мт';
const COMMISSION_RATE = 0.125;
function roundReportanMoney(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
function parseReportanMoney(value) {
    const firstAmount = /-?\d[\d,]*(?:\.\d+)?/.exec(value)?.[0] ?? '';
    const parsed = Number(firstAmount.replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
}
function normalizeReportanSource(value) {
    return (value ?? '').trim().toLocaleLowerCase('ru-RU');
}
function signedContractorShare(adjustment) {
    const share = adjustment.shareAmountOverride == null ? adjustment.grossAmount * 0.5 : adjustment.shareAmountOverride;
    return adjustment.direction === 'CREDIT_IGOR' ? share : -share;
}
function getIgorPayrollPeriodBounds(periodKey) {
    const match = /^(\d{4})-(\d{2})$/.exec(periodKey);
    if (!match)
        throw new Error('invalid-period-key');
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (month < 1 || month > 12)
        throw new Error('invalid-period-key');
    const previousMonth = new Date(Date.UTC(year, month - 2, 11));
    return { start: previousMonth.toISOString().slice(0, 10), end: `${periodKey}-10` };
}
function calculateIgorPayroll(input) {
    const { start, end } = getIgorPayrollPeriodBounds(input.periodKey);
    const qualifying = input.visits.filter((visit) => {
        const sources = [normalizeReportanSource(visit.closer), normalizeReportanSource(visit.sheetSource)];
        return visit.date >= start && visit.date <= end
            && visit.deletedFromSchedule !== true
            && visit.operationalStatus !== 'cancelled' && visit.operationalStatus !== 'postponed'
            && sources.includes(IGOR_SOURCE) && parseReportanMoney(visit.price) > 0;
    });
    const qualifyingRevenue = roundReportanMoney(qualifying.reduce((sum, visit) => sum + parseReportanMoney(visit.price), 0));
    const commission = roundReportanMoney(qualifyingRevenue * COMMISSION_RATE);
    const qualifyingVisits = qualifying.map((visit) => {
        const price = parseReportanMoney(visit.price);
        return {
            date: visit.date,
            time: visit.time ?? '',
            address: visit.address ?? '',
            phone: visit.phone ?? '',
            name: visit.name,
            price,
            commission: roundReportanMoney(price * COMMISSION_RATE),
        };
    });
    const contractorAdjustmentTotal = roundReportanMoney(input.period.contractorAdjustments.reduce((sum, item) => sum + signedContractorShare(item), 0));
    const total = roundReportanMoney(commission + contractorAdjustmentTotal + input.period.carryIn + input.period.manualAdjustment);
    return { periodStart: start, periodEnd: end, qualifyingVisitCount: qualifying.length, qualifyingVisits, qualifyingRevenue, commission, contractorAdjustmentTotal, carryIn: input.period.carryIn, manualAdjustment: input.period.manualAdjustment, total };
}
